import { render, staticRenderFns } from "./magiczoom.vue?vue&type=template&id=545dbc69&"
import script from "./magiczoom.vue?vue&type=script&lang=js&"
export * from "./magiczoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/51881/189/Woerner/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545dbc69')) {
      api.createRecord('545dbc69', component.options)
    } else {
      api.reload('545dbc69', component.options)
    }
    module.hot.accept("./magiczoom.vue?vue&type=template&id=545dbc69&", function () {
      api.rerender('545dbc69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/single/magiczoom.vue"
export default component.exports